var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,_vm._b({ref:"widget",tag:"component",attrs:{"settings":_vm.settings,"value":_vm.content}},'component',{ ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }